<template>
  <div class="base-switch">
    <input
      :id="id"
      v-model="model"
      class="base-switch__checkbox sr-only"
      type="checkbox"
      role="switch"
      :aria-checked="model"
    />
    <label class="base-switch__label" :for="id">
      <div class="base-switch__switch"></div>
      {{ label }}
    </label>
  </div>
</template>

<script setup lang="ts">
import useId from '../../../composables/useId';

const id = `switch-${useId()}`;

withDefaults(
  defineProps<{
    modelValue?: boolean;
    label?: string;
  }>(),
  {
    modelValue: false,
    label: 'Switch',
  }
);

const model = defineModel<boolean>();
</script>

<style lang="scss">
@import './scss/BaseSwitch.scss';
</style>
